import { AxiosResponse } from "axios";
import { FeedContentLoadStatus, FeedItemDto, FeedType, PublicationType } from "generated/CoreApi_v1";
import { JSX } from "react";
import FeedItemHelper from "views/knowledge/components/card/FeedItemHelper";


export type CardBehaviorFC<P = {}> = (props: P) => React.ReactNode;

export type PublicationFeed = FeedItemDto;

export type PublicationOtherChanges = {
    relationshipChanged?: boolean;
};

export type CardSections =
    | "priorityHeader"
    | "mediaHeader"
    | "classification"
    | "icons"
    | "externalLeftThumbnail"
    | "leftThumbnail"
    | "rightThumbnail"
    | "author"
    | "title"
    | "content"
    | "media"
    | "attach"
    | "task"
    | "footer"
    ;

export type CardLocalContent = {
    content: string | null | undefined,
    contentLoadStatus: FeedContentLoadStatus;
    state: CardLocalContentState;
};

export type CardLocalContentState = undefined | "expanded" | "contracted";

export type CardBehaviorJSX = () => JSX.Element;

export type CardSectionProps = {
    PriorityHeader?: CardBehaviorFC;
    MediaHeader?: CardBehaviorFC;
    Classification?: CardBehaviorFC;
    Icons?: CardBehaviorFC;
    ExternalLeftThumbnail?: CardBehaviorFC;
    LeftThumbnail?: CardBehaviorFC;
    RightThumbnail?: CardBehaviorFC;
    Title?: CardBehaviorFC;
    Author?: CardBehaviorFC;
    Content?: CardBehaviorFC;
    Media?: CardBehaviorFC;
    Attach?: CardBehaviorFC;
    Task?: CardBehaviorFC;
    Footer?: CardBehaviorFC;
};

export type CardContextType = {
    pub: PublicationFeed;
    localContent: CardLocalContent;
    cardDivRef: HTMLDivElement | null;
    otherInfo?: any;
    cardOwnProps: CardOwnPropsOptions;
    helper: FeedItemHelper;
    onFeedItemChanged: (data: Partial<PublicationFeed>, otherChanges?: PublicationOtherChanges) => void;
    onUpdateLocalContent: (data: CardLocalContent) => void;
    onUpdateCardOwnProps: (data: Partial<CardOwnPropsOptions>) => void;
    onReload: () => void;
    onFeedReload?: () => void;
    onMarkRead?: () => Promise<AxiosResponse<boolean, any>>;
};

export enum BehaviorMode {
    Default = 1,
    Thread = 2,
    Blocked = 4,
    Deleted = 8,
    Hidden = 16,
    ModerateComment = 32
}

export type BehaviorDefinition = {
    publicationType: PublicationType;
    feedType: FeedType;
    mode: BehaviorMode;
    section: CardSections,
    behavior: CardBehaviorFC;
};

export type CardVideoSearch = {
    attachId: string;
    searchText: string;
};

export type CardOwnPropsOptions = {
    publicationId: string,
    presentation: {
        autoplay: boolean;
        lighboxOpened: boolean;
        currentAttachId: string | null;
        currentIsVideo: boolean | null;
    },
    videoAutoPlay?: boolean;
    search?: CardVideoSearch;
};
